import { Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { CollapsibleFilterField } from './CollapsibleFilterField';
import { FilterField } from './FilterField';

export interface CheckboxFilterOption<T extends string | number> {
  label: ReactNode;
  value: T;
  'aria-label'?: string;
  disabled?: boolean;
}

export interface CheckboxFilterGroupProps<T extends string | number> {
  label: string;
  options: CheckboxFilterOption<T>[];
  selected: T[];
  onToggle: (value: T) => void;
  collapsible?: boolean;
  defaultOpen?: boolean;
  indent?: number;
}

export function CheckboxFilterGroup<T extends string | number>({
  label,
  options,
  selected,
  onToggle,
  collapsible = false,
  defaultOpen = true,
  indent = 1,
}: CheckboxFilterGroupProps<T>) {
  const checkboxes = (
    <FormGroup sx={{ pl: indent, '& .MuiCheckbox-root': { py: 0.25 } }}>
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          aria-label={option['aria-label']}
          disabled={option.disabled}
          label={
            typeof option.label === 'string' ? (
              <Typography variant="body2">{option.label}</Typography>
            ) : (
              option.label
            )
          }
          control={
            <Checkbox
              size="small"
              checked={selected.includes(option.value)}
              onChange={() => onToggle(option.value)}
            />
          }
        />
      ))}
    </FormGroup>
  );

  return collapsible ? (
    <CollapsibleFilterField label={label} defaultOpen={defaultOpen}>
      {checkboxes}
    </CollapsibleFilterField>
  ) : (
    <FilterField label={label}>{checkboxes}</FilterField>
  );
}
